import ApiService from '@/services/ApiService';

export default class BreedingSessionsApiService extends ApiService {
    constructor() {
        super('breeding_sessions');
    }
}
